<template>
  <div class="py-4" id="content-header">
    <b-breadcrumb class="mb-0 p-0">
      <b-breadcrumb-item v-for="(item, index) in items" :key="index" active>{{
        item
      }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="row">
      <h1 class="h4 pt-2 col-sm col-12">{{ title }}</h1>
      <div class="col-sm col-12" v-if="page_name != '該頁無法顯示'">
        <b-input-group
          class="mb-2 ml-auto"
          id="search"
          v-if="page_name != '報表'"
        >
          <b-input-group-prepend is-text>
            <b-button
              @click="onSearch"
              variant="link"
              class="p-0 text-secondary"
            >
              <b-icon-search></b-icon-search>
            </b-button>
          </b-input-group-prepend>
          <b-form-input
            v-model="search"
            :placeholder="search_placeholder"
            @keydown.enter="onSearch"
          ></b-form-input>
          <b-button-close
            class="pr-2"
            v-if="search"
            @click="clearFilter"
          ></b-button-close>
          <b-button
            v-if="page_name == '商品管理'"
            variant="link"
            class="nav-link p-0 pr-2"
            :class="{ has_filter: hasFilter }"
            v-b-toggle.collapse-1
          >
            <b-icon icon="funnel" variant="cms_main"></b-icon>
            <small class="text-cms_main">篩選</small>
          </b-button>
        </b-input-group>
      </div>
    </div>
    <b-collapse id="collapse-1" class="mt-2" v-if="page_name == '商品管理'">
      <div class="pt-2 row align-items-end">
        <div class="col-12 col-sm-auto">
          <b-form-group label="汽車動力類型：" label-for="filterProductType">
            <select
              id="filterProductType"
              class="custom-select rounded-0"
              v-model="filter_condition.type"
            >
              <option value="" selected>請選擇</option>
              <option
                v-for="val in type_list"
                :key="val.value"
                :value="val.value"
              >
                {{ val.name }}</option
              >
            </select>
          </b-form-group>
        </div>
        <div class="col-12 col-sm-auto">
          <b-form-group label="汽車品牌：" label-for="">
            <select
              id=""
              class="custom-select rounded-0"
              v-model="filter_condition.brand"
            >
              <option value="" selected>請選擇</option>
              <option
                v-for="val in car_brand_list"
                :key="val.id"
                :value="val.id"
              >
                {{ val.name }}</option
              >
            </select>
          </b-form-group>
        </div>
        <div class="col-12 col-sm-auto">
          <b-form-group label="汽車車款：" label-for="">
            <select
              id=""
              class="custom-select rounded-0"
              v-model="filter_condition.model"
              :disabled="!model_list.length"
            >
              <option value="" selected>請選擇</option>
              <option v-for="val in model_list" :key="val.id" :value="val.id">
                {{ val.name }}</option
              >
            </select>
          </b-form-group>
        </div>
        <div class="col-12 col-sm-auto">
          <b-form-group label="汽車年份/c.c.數：" label-for="">
            <select
              id=""
              class="custom-select rounded-0"
              v-model="filter_condition.year"
              :disabled="!year_list.length"
            >
              <option value="" selected>請選擇</option>
              <option v-for="val in year_list" :key="val.id" :value="val.id">
                {{ val.name }}</option
              >
            </select>
          </b-form-group>
        </div>
        <div class="col-12 col-sm-auto">
          <b-form-group label="零件類型：" label-for="filterProductCategory">
            <select
              id="filterProductCategory"
              class="custom-select rounded-0"
              v-model="selectFilter.part_category"
            >
              <option value="" selected>請選擇</option>
              <option v-for="val in tag_list" :key="val.id" :value="val.name">
                {{ val.name }}</option
              >
            </select>
          </b-form-group>
        </div>
        <div class="col-12 col-sm-auto">
          <b-form-group label="零件品牌：" label-for="filterPartsBrand">
            <select
              id="filterPartsBrand"
              class="custom-select rounded-0"
              v-model="selectFilter.part_brand"
            >
              <option value="" selected>請選擇</option>
              <option
                v-for="val in brands_list"
                :key="val.id"
                :value="val.name"
              >
                {{ val.name }}</option
              >
            </select>
          </b-form-group>
        </div>
        <div class="col-12 col-sm-auto">
          <b-button
            squared
            variant="cms_main"
            type="button"
            size="sm"
            class="mr-3 mb-3"
            @click="onFilter"
            >篩選</b-button
          >
          <b-button
            squared
            variant="outline-cms_main"
            type="button"
            size="sm"
            class="mr-3 mb-3"
            @click="clearSelectFilter"
            >重置</b-button
          >
          <b-button
            squared
            variant="outline-secondary"
            type="button"
            size="sm"
            class="mb-3"
            v-b-toggle.collapse-1
            >關閉</b-button
          >
        </div>
      </div>
      <div class="pt-2 row align-items-end"></div>
    </b-collapse>
  </div>
</template>

<style lang="scss">
#content-header {
  background-color: #fff;
  padding-right: $content_x_padding;
  padding-left: $content_x_padding;
  @include media-breakpoint-down(sm) {
    padding-right: $content_x_padding-sm;
    padding-left: $content_x_padding-sm;
  }
}
.breadcrumb {
  background-color: transparent;
  &-item {
    font-size: 14px;
  }
}
#search {
  max-width: 300px;
  border-bottom: 1px solid #bdbdbd;
  @include media-breakpoint-down(xs) {
    border: 1px solid #bdbdbd;
    max-width: 100%;
    margin-top: 20px;
  }
  .input-group-text {
    background-color: transparent;
    border: none;
    border-radius: 0;
    color: #bdbdbd;
  }
  .form-control {
    border: none;
    border-radius: 0;
    &:focus {
      box-shadow: none;
    }
  }
}
.has_filter {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 5px;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 5px;
    background-color: #dc3545;
  }
}
</style>

<script>
import { Product } from "@/assets/api/cms.js";
import { Toast } from "@/plugins/sweetalert2.js";
import { getPartBrand } from "@/assets/api.config.js";

export default {
  props: ["page_name", "token"],
  data() {
    return {
      hasFilter: false,
      title: this.page_name,
      search: null,
      brands_list: null,
      tag_list: null,
      selectFilter: {
        part_brand: "",
        part_category: ""
      },
      type_list: [
        {
          name: "汽油車",
          value: "gas"
        },
        {
          name: "油電車",
          value: "hybrid"
        },
        {
          name: "電動車",
          value: "electric"
        },
        {
          name: "柴油車",
          value: "diesel"
        }
      ],
      car_brand_list: [],
      model_list: [],
      year_list: [],
      category_list: [],
      filter_condition: {
        type: "",
        brand: "",
        model: "",
        year: ""
      }
    };
  },
  created() {},
  computed: {
    items() {
      switch (this.page_name) {
        case "業務":
        case "管理者":
          return ["首頁", "帳號管理", this.page_name];
        default:
          return ["首頁", this.page_name];
      }
    },
    search_placeholder() {
      switch (this.page_name) {
        case "商品管理":
          return "搜尋商品編號、名稱";
        case "業務區域管理":
          return "搜尋業務區域名稱";
        case "業務":
          return "搜尋業務姓名";
        case "管理者":
          return "搜尋管理者姓名";
        default:
          return "搜尋";
      }
    },
    queryObj() {
      let data = {};
      if (this.search) {
        data.search = this.search;
      }
      if (this.page_name !== "商品管理") return data;

      if (this.selectFilter.part_brand) {
        data.part_brand = this.selectFilter.part_brand;
      }
      if (this.selectFilter.part_category) {
        data.part_category = this.selectFilter.part_category;
      }
      if (this.filter_condition.type) {
        data.card_type = this.filter_condition.type;
      }
      if (this.filter_condition.brand) {
        data.card_brand = this.filter_condition.brand;
      }
      if (this.filter_condition.model) {
        data.card_model = this.filter_condition.model;
      }
      if (this.filter_condition.year) {
        data.card_year = this.filter_condition.year;
      }
      return data;
    },
    allYears() {
      if (this.page_name !== "商品管理") return "";
      let data = [];
      this.category_list.forEach(item => {
        if (this.filter_condition.brand) {
          if (item.id == this.filter_condition.brand) {
            item.models.forEach(model => {
              if (this.filter_condition.models) {
                if (model.id == this.filter_condition.models) {
                  model.years.forEach(year => {
                    if (this.filter_condition.type) {
                      if (year.type == this.filter_condition.type) {
                        data.push(year);
                      }
                    } else {
                      data.push(year);
                    }
                  });
                }
              } else {
                model.years.forEach(year => {
                  if (this.filter_condition.type) {
                    if (year.type == this.filter_condition.type) {
                      data.push(year);
                    }
                  } else {
                    data.push(year);
                  }
                });
              }
            });
          }
        } else {
          item.models.forEach(model => {
            model.years.forEach(year => {
              if (this.filter_condition.type) {
                if (year.type == this.filter_condition.type) {
                  data.push(year);
                }
              } else {
                data.push(year);
              }
            });
          });
        }
      });
      return data;
    },
    carBrand() {
      if (this.page_name !== "商品管理") return "";
      let data = [];
      this.category_list.forEach(item => {
        data.push({
          id: item.id,
          name: item.name
        });
      });
      return data;
    },
    carModels() {
      if (this.page_name !== "商品管理") return "";
      let data = [];
      this.category_list.forEach(item => {
        if (!this.filter_condition.brand) return;
        if (item.id == this.filter_condition.brand) {
          item.models.forEach(model => {
            if (data.length) {
              for (let index = 0; index < data.length; index++) {
                if (data[index].id == model.id) return;
              }
            }
            data.push({
              id: model.id,
              name: model.name
            });
          });
        }
      });
      return data;
    }
  },
  watch: {
    queryObj(val) {
      this.hasFilter = Object.keys(val).length ? true : false;
    },
    "filter_condition.type": function(val) {
      this.car_brand_list = [];
      this.model_list = [];
      this.year_list = [];
      this.filter_condition.brand = "";
      this.filter_condition.model = "";
      this.filter_condition.year = "";
      if (val) {
        this.allYears.forEach(year => {
          if (year.type == val) {
            const name = this.getBrandName(year.car_brand_id);
            if (this.car_brand_list.length) {
              for (let index = 0; index < this.car_brand_list.length; index++) {
                if (this.car_brand_list[index].id == year.car_brand_id) return;
              }
            }
            this.car_brand_list.push({
              id: year.car_brand_id,
              name: name
            });
          }
        });
      } else {
        this.car_brand_list = [...this.carBrand];
      }
    },
    "filter_condition.brand": function(val) {
      this.model_list = [];
      this.year_list = [];
      this.filter_condition.model = "";
      this.filter_condition.year = "";
      if (val) {
        this.allYears.forEach(year => {
          if (
            year.car_brand_id == val &&
            (this.filter_condition.type
              ? year.type == this.filter_condition.type
              : true)
          ) {
            const name = this.getModelsName(year.car_model_id);
            if (this.model_list.length) {
              for (let index = 0; index < this.model_list.length; index++) {
                if (this.model_list[index].id == year.car_model_id) return;
              }
            }
            this.model_list.push({
              id: year.car_model_id,
              name: name
            });
          }
        });
      }
    },
    "filter_condition.model": function(val) {
      this.year_list = [];
      this.filter_condition.year = "";
      if (val) {
        this.allYears.forEach(year => {
          if (
            year.car_model_id == val &&
            (this.filter_condition.type
              ? year.type == this.filter_condition.type
              : true)
          ) {
            if (this.year_list.length) {
              for (let index = 0; index < this.year_list.length; index++) {
                if (this.year_list[index].id == year.id) return;
              }
            }
            this.year_list.push({
              id: year.id,
              name: year.publish_year + "/" + year.displacing + "c.c."
            });
          }
        });
      }
    },
    page_name(data) {
      this.title = data;
      if (data == "商品管理") {
        Product.getTag(this.token)
          .then(res => {
            if (res.status <= 201) {
              this.tag_list = res.data;
            } else {
              Toast.fire({
                icon: "error",
                title: "零件分類資料取得失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
        getPartBrand()
          .then(res => {
            if (res.status <= 201) {
              this.brands_list = res.data;
            } else {
              Toast.fire({
                icon: "error",
                title: "零件品牌資料取得失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });

        Product.getCategory(this.token)
          .then(res => {
            this.category_list = res.data.data;
            this.car_brand_list = [...this.carBrand];
          })
          .catch(err => {
            console.error(err);
          });
      }
    }
  },
  methods: {
    onFilter() {
      this.$router
        .push({
          query: this.queryObj
        })
        .catch(err => {
          err;
        });
    },
    clearFilter() {
      this.search = null;
      this.$router
        .push({
          query: this.queryObj
        })
        .catch(err => {
          err;
        });
    },
    clearSelectFilter() {
      this.selectFilter.part_brand = "";
      this.selectFilter.part_category = "";
      this.filter_condition.type = "";
      this.filter_condition.brand = "";
      this.filter_condition.model = "";
      this.filter_condition.year = "";
      this.$router
        .push({
          query: ""
        })
        .catch(err => {
          err;
        });
    },
    getBrandName(id) {
      let name = "";
      this.carBrand.forEach(item => {
        if (item.id == id) {
          name = item.name;
        }
      });
      return name;
    },
    getModelsName(id) {
      let name = "";
      this.carModels.forEach(item => {
        if (item.id == id) {
          name = item.name;
        }
      });
      return name;
    },
    onSearch() {
      if (this.search) {
        this.$router
          .push({
            query: this.queryObj
          })
          .catch(err => {
            err;
          });
      }
    }
  },
  mounted() {
    this.search = this.$route.query.search;
  }
};
</script>
